var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2281 8.67434L13.5898 12.3126L17.2281 15.9508L16.8392 16.3397C16.1952 16.9837 15.1502 16.9837 14.5061 16.3397L12.0344 13.868L9.56274 16.3397C8.91869 16.9837 7.87369 16.9837 7.22964 16.3397L6.84079 15.9508L10.479 12.3126L6.84079 8.67434L7.22964 8.28549C7.87369 7.64144 8.91869 7.64144 9.56274 8.28549L12.0344 10.7572L14.5061 8.28549C15.1502 7.64144 16.1952 7.64144 16.8392 8.28549L17.2281 8.67434Z",
    fill: "#B30909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0925 21.3397C17.0631 21.3397 21.0925 17.3103 21.0925 12.3397C21.0925 7.36913 17.0631 3.33969 12.0925 3.33969C7.12197 3.33969 3.09253 7.36913 3.09253 12.3397C3.09253 17.3103 7.12197 21.3397 12.0925 21.3397ZM12.0925 23.3397C18.1677 23.3397 23.0925 18.4148 23.0925 12.3397C23.0925 6.26456 18.1677 1.33969 12.0925 1.33969C6.0174 1.33969 1.09253 6.26456 1.09253 12.3397C1.09253 18.4148 6.0174 23.3397 12.0925 23.3397Z",
    fill: "#B30909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossmark);
export default __webpack_public_path__ + "static/media/crossmark.24b696b4333549c88521121ef58daf33.svg";
export { ForwardRef as ReactComponent };